import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {AppComponent} from '../../app.component';
import {ExgPopupComponent} from 'exc-controls-v2';

@Component({
  selector: 'app-exg-dropdown',
  templateUrl: './exg-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class ExgDropdownComponent extends ExcTranslation implements OnInit, OnDestroy, AfterViewInit {


  @Input() list: any[] = [];
  @Input() listdisplay: string | undefined = undefined;
  @Input() label = 'Missing label';
  @Input() position = 'underleft';
  @Input() maxHeight = 'inherit';
  @Input() elementclass = '';
  @Input() disabled: any = false;
  @Input() adaptiveHeightActive = false;
  @Input() adaptiveHeightOffset = 625;


  @ContentChild('hostTemplate') hostElement: TemplateRef<ElementRef> | null = null;
  @ContentChild('contentTemplate') contentElement: TemplateRef<ElementRef> | null = null;

  @ViewChild(ExgPopupComponent) VCDropdown!: ExgPopupComponent;
  @ViewChild('test', {static: true}) popup!: TemplateRef<any>;
  @ViewChild('blind', {static: true, read: ViewContainerRef}) blindasda!: ViewContainerRef;

  added = false;

  // tslint:disable-next-line:no-output-native
  @Output() change: EventEmitter<{ index: number, value: any }> = new EventEmitter<{ index: number, value: any }>();

  constructor(private app: AppComponent, private cfResolver: ComponentFactoryResolver,
              public vcRef: ViewContainerRef,
              private renderer: Renderer2) {
    super();
  }

  ngOnDestroy(): void {
    ExcCoreModule.Array.Remove(this.app.childs, this.popup);
  }

  ngOnInit(): void {
    this.app.childs.push(this.popup);
  }

  togglePopupMenu(e: any, context: any, pos: string = 'underleft'): void {
    if (this.disabled) {
      return;
    }
    if (context) {
      if (context.visibility === 'hidden') {
        switch (pos) {
          case 'underleft': {
            context.openUnderLeft(e);
            break;
          }
          case 'abovecenter': {
            context.openAboveCenter(e);
            break;
          }
          case 'undercenter': {
            context.openUnderCenter(e);
            break;
          }
          case 'underright': {
            context.openUnderRight(e);
            break;
          }
        }
      } else {
        context.close();
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.added = true;
    }, 0);

  }

}
